// this file added by Bearer Web Developer (CancellationCostState)
import { Instance, types } from "mobx-state-tree";
export type TCancellationCost = "2.1" | "2.2.1" | "2.2.2" | "3.1" | "3.2";
export const CancellationCostState = types
    .model("CancellationCostState", {
        cancellingStateCode: types.maybeNull(types.frozen<TCancellationCost>()),
        timeN: types.maybeNull(types.string),
        timeM: types.maybeNull(types.string),
        cancellationFee: types.maybeNull(types.number),
        waitingFee: types.maybeNull(types.number),
        totalCancellation: types.maybeNull(types.number),
        timer: types.maybeNull(types.number), // by the minute
    })
    .actions(self => {
        return {
            reset() {
                self.cancellingStateCode = null;
                self.timeN = null;
                self.timeM = null;
                self.cancellationFee = null;
                self.waitingFee = null;
                self.totalCancellation = null;
                self.timer = null;
            },
            setCancellationCost(value: {
                cancellingStateCode: TCancellationCost,
                timeN: string,
                timeM: string,
                cancellationFee: number,
                waitingFee: number,
                totalCancellation: number,
                timer: number,
            }) {
                self.cancellingStateCode = value.cancellingStateCode;
                self.timeN = value.timeN;
                self.timeM = value.timeM;
                self.cancellationFee = value.cancellationFee;
                self.waitingFee = value.waitingFee;
                self.totalCancellation = value.totalCancellation;
                self.timer = value.timer;
            }
        }
    })
export interface ICancellationCostState extends Instance<typeof CancellationCostState> { };

